
<div class="">
    <div class="container-fluid shipment-details" style="height: 100vh;">
      <div class="row">
        <div class="col doc-header">
            Sample details
        </div>
        <div class="col-auto ml-auto doc-header">
          ID: {{sampleDetails.id}}
        </div>
      </div>
      <div class="row mt-40">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Type:
          </div>
          <div class="value">
            {{sampleDetails.type}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Location:
          </div>
          <div class="value">
            {{sampleDetails.location}}
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Status:
          </div>
          <div class="value">
            {{sampleDetails.status}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Tests assigned:
          </div>
          <div class="value">
            {{sampleDetails.testAssigned}}
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Cart ID:
          </div>
          <div class="value">
            {{sampleDetails.cartId}}
          </div>
        </div>
        <div class="col-6 doc-wrapper">
          <div class="label">
            Ongoing test:
          </div>
          <div class="value">
            {{sampleDetails.onGoingTest}}
          </div>
        </div>
      </div>
      <div class="row mt-24">
        <div class="col-6 doc-wrapper">
          <div class="label">
            Date of collection:
          </div>
          <div class="value">
            {{sampleDetails.dateOfCollection|date:'dd/MM/yyyy'}}
          </div>
        </div>
      </div>
      <div class="row mt-40">
        <div class="col-12">
          <table class="table inner-table">
            <thead>
              <tr>
                <th scope="col">Tasks</th>
                <th scope="col">Location</th>
                <th scope="col">Result </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="sampleDetails.details">
                <tr *ngFor="let task of sampleDetails.details">
                  <td>{{task.task}}</td>
                  <td>{{task.location}}</td>
                  <td>{{task.result?task.result:'-'}}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="!sampleDetails.details || 
              (sampleDetails.details && 
              sampleDetails.details.length == 0)">
                <tr>
                  <td colspan="3" style="text-align: center;">There are no samples available</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>